import React from "react";
import HotelSubNavbar from "./HotelSubNavbar";

const Hotel = () => {
  return (
    <div>
      <HotelSubNavbar />
    </div>
  );
};

export default Hotel;
